import Hero from "@/components/Hero";
import TrustBar from "@/components/TrustBar";
import BrandLogos from "@/components/BrandLogos";
import RegionStrip from "@/components/RegionStrip";
import AIFirstMethodology from "@/components/AIFirstMethodology";
import Services from "@/components/Services";
import ProblemsAndSolutions from "@/components/ProblemsAndSolutions";
import VideoShowcase from "@/components/VideoShowcase";
import Process from "@/components/Process";
import VideoTestimonials from "@/components/VideoTestimonials";
import ClientFeedbacks from "@/components/ClientFeedbacks";
import Contact from "@/components/Contact";
import Footer from "@/components/Footer";
import SEO from "@/components/SEO";

const Index = () => {
  return (
    <main className="min-h-screen">
      <SEO
        title="Ihre Experten für Videoproduktionen aus Aachen – Aivinity"
        description="Aivinity (ehemals JC Productions) — AI-first Video- & Content-Agentur aus Aachen. Imagefilme, Testimonials, KI-Filme, Reels und Social Media Management in Aachen, Köln, Düsseldorf & ganz NRW."
        canonical="/"
      />
      <Hero />
      <TrustBar />
      <BrandLogos />
      <AIFirstMethodology />
      <Services />
      <VideoShowcase />
      <ProblemsAndSolutions />
      <Process />
      <VideoTestimonials />
      <ClientFeedbacks />
      <RegionStrip />

      {/* Rebranding Section for SEO */}
      <section className="py-12 md:py-16 border-t border-border/30">
        <div className="container mx-auto px-4 md:px-6 max-w-4xl text-center">
          <h2 className="text-xl md:text-2xl font-halenoir font-normal tracking-tight mb-3 text-foreground/80">
            Aivinity – ehemals JC Productions
          </h2>
          <p className="text-sm md:text-base text-muted-foreground max-w-2xl mx-auto leading-relaxed">
            Aivinity ist die Weiterentwicklung von JC Productions. Unter neuem Namen verbinden wir strategische Konzeption mit moderner, AI-first Videoproduktion in Kinoqualität – für Unternehmen in Aachen, Köln, Düsseldorf und ganz NRW.
          </p>
        </div>
      </section>

      <Contact />
      <Footer />
    </main>
  );
};

export default Index;
